import { getElementRef } from "../utils/getElementRef"
import { EMITS as SELECTCORE_EMITS } from "../index"
import { isTouchDevice } from "../utils/isTouchDevice"
const fuzzysort = require("fuzzysort")

export class SearchPlugin {
    constructor() {
        this.ref = {}
        this.noResultEl = null
        this.isFocus = false
    }

    options() {
        return {
            searchIsEnabled: true,
            searchMinOptions: 10,
            searchNoResultTemplate: `<div class="Select-noResult">Nebyly nalezeny žádné výsledky</div>`,
            searchTemplate: `<div class="Select-search" data-search><input type="text" placeholder="Vyhledat..." data-searchinput/></div>`,
        }
    }

    setup(inst) {
        this.inst = inst

        if (!this.inst.options.searchIsEnabled || this.inst.choices.length < this.inst.options.searchMinOptions) {
            return
        }

        this.ref.search = getElementRef(this.inst.ref.dropdown, "search", this.inst.options)
        this.ref.searchInput = getElementRef(this.ref.search, "searchinput", this.inst.options)

        this.inst.choices.forEach((choice) => {
            choice.normalizedSearchValue = choice.optionEl.innerText.normalize("NFD").replace(/\p{Diacritic}/gu, "")
        })

        this.inst.element.addEventListener("focus", this.handleFocus)
        this.inst.element.addEventListener("blur", this.handleBlur)

        this.inst.ref.placeholder.addEventListener("click", this.handlePlaceholderClick)
        this.ref.searchInput.addEventListener("change", this.handleSearchInputChange)
        this.ref.searchInput.addEventListener("input", this.handleSearchInputInput)
        this.ref.searchInput.addEventListener("focus", this.handleSearchInputFocus)
        this.ref.searchInput.addEventListener("blur", this.handleSearchInputBlur)

        this.inst.on(SELECTCORE_EMITS.OPEN, this.handleOpen)

        inst.element.classList.add("is-search-enabled")
    }

    handleOpen = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (!isTouchDevice()) {
                    this.ref.searchInput.focus()
                }
            })
        })
    }

    handleFocus = () => {
        this.isFocus = true
    }

    handleBlur = () => {
        this.isFocus = false
    }

    handleSearchInputChange = event => {
        event.stopPropagation()
    }

    handleSearchInputFocus = (event) => {
        cancelAnimationFrame(this.inst.closeRaf)
    }

    handleSearchInputBlur = (event) => {
        setTimeout(() => {
            if (!this.isFocus) {
                this.inst.closeList()
            }
        }, 100)
    }

    handleSearchInputInput = (event) => {
        let value = event.currentTarget.value
        value = value.normalize("NFD").replace(/\p{Diacritic}/gu, "")

        if (value) {
            const results = fuzzysort.go(value, this.inst.choices, {
                key: "normalizedSearchValue",
            })

            const shouldRenderNoResult = (results.length == 0 && !this.noResultEl)

            if (results.length > 0 || shouldRenderNoResult) {
                this.inst.render({
                    choices: results.map((result) => result.obj),
                })
            }

            if (shouldRenderNoResult) {
                const buffer = document.createElement("div")
                buffer.innerHTML = this.inst.options.searchNoResultTemplate
                this.noResultEl = buffer.firstElementChild
                this.inst.ref.list.appendChild(this.noResultEl)
                this.inst.element.classList.add("is-search-noresult")
            }
        } else {
            this.inst.render({
                choices: this.inst.allChoices,
            })

            if (this.noResultEl && this.noResultEl.parentNode) {
                this.noResultEl.parentNode.removeChild(this.noResultEl)
                this.inst.element.classList.remove("is-search-noresult")
            }

            this.noResultEl = null
        }
    }
}
